:host {
  --empty-state--display: none;
}
:host,
:host * {
  box-sizing: border-box;
}
details {
  border-radius: var(--Common--border-radius);
  padding: var(--spacer-3);
  margin-bottom: var(--spacer-4);
}
summary {
  display: flex;
  gap: var(--spacer-2);
  cursor: pointer;
}
summary:where(::-webkit-details-marker, ::marker) {
  display: none;
}
#title {
  font-weight: 600;
}
fa-icon {
}
#expansion-icon {
  margin-left: auto;
}
#default-expansion-icon {
  transform-origin: center;
  transform: rotate(0deg);
  transition: transform 0.3s;
  cursor: pointer;
  font-weight: 600;
}
:host([open]) #default-expansion-icon {
  transform: rotate(90deg);
}
aha-tree {
  min-height: var(--aha-toc--temp-height, 'auto');
}
aha-tree,
#empty-state {
  margin-top: var(--spacer-2);
}
details:has(aha-tree-item) {
  display: block;
  & + #empty-state {
    display: none;
  }
}
details:not(:has(aha-tree-item)) {
  display: none;
  & + #empty-state {
    display: block;
  }
}
